export default function techinicalteamorganizations(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                techinicalteamorganization: action.techinicalteamorganization,
            }
        default:
            return state;
    }
}
